/**
 * Mobile Performance CSS Optimizations
 * Các tối ưu hóa CSS để cải thiện hiệu năng trên mobile
 */

// Mobile-specific CSS optimizations
export const mobileOptimizations = `
/* Hardware acceleration cho mobile */
.mobile-tabs-container,
.mobile-tab,
.tab-label {
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

/* Optimize transitions */
.mobile-tab {
  transition: background-color 0.15s ease-out;
  will-change: background-color;
}

.tab-label {
  transition: color 0.15s ease-out;
  will-change: color;
}

/* Reduce repaints */
.mobile-tabs-container {
  contain: layout style paint;
}

/* Optimize for touch */
.mobile-tab {
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

/* Reduce layout thrashing */
.mobile-tabs {
  contain: layout;
}

/* Optimize font rendering */
.tab-label {
  text-rendering: optimizeSpeed;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Reduce memory usage */
@media screen and (max-width: 768px) {
  * {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
  
  /* Disable expensive effects on mobile */
  .mobile-tab:hover {
    background-color: transparent;
  }
  
  /* Optimize scrolling */
  .mobile-tabs-container {
    -webkit-overflow-scrolling: touch;
  }
}
`;

// Apply mobile optimizations
export function applyMobileOptimizations() {
  if (window.innerWidth <= 768) {
    const style = document.createElement('style');
    style.textContent = mobileOptimizations;
    style.setAttribute('data-mobile-optimizations', 'true');
    document.head.appendChild(style);
  }
}

// Remove mobile optimizations when switching to desktop
export function removeMobileOptimizations() {
  const existingStyle = document.querySelector('style[data-mobile-optimizations="true"]');
  if (existingStyle) {
    existingStyle.remove();
  }
}



// WEBPACK FOOTER //
// ./src/utils/mobile-css-optimizer.js